export const emptyTracker = {
  clone: () => emptyTracker,
  track: () => undefined
};
export const isEmptyTracker = tracker => tracker === emptyTracker;